/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

const baseStyles = () => {
    /* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
    return css`
        .sku {
            display: block;
            text-align: center;
            ${theme.typography.body_small};
            color: var(--colors-text-primary);
        }
    `;
    /* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
};

export const styles = () => css`
    ${baseStyles()}
`;
